import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { createNewProject } from '../../store/actions/Dashboard';
import { routesAction } from '../../shared/helpers';
import './DashboardMessage.css';

const DashboardMessage = ({ children, history }) => {
  const handleCreateProject = () => {
    history.push(routesAction.onboarding());
  };

  return (
    <div className="col-md-6 offset-md-3 align-content-center text-center">
      {children}
      <h4>Welcome to your dashboard!</h4>
      <p className="text-gray-2 t-16 font-weight-md-mid message">
        You can
        <a className="new-project" onClick={handleCreateProject}>
          {' create a new project '}
        </a>
        or view previously submitted ones.
      </p>
    </div>
  );
};

DashboardMessage.propTypes = {
  children: PropTypes.any,
  dispatchCreateNewProject: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

const mapDispatchToProps = dispatch => ({
  dispatchCreateNewProject: loggedUser =>
    dispatch(createNewProject(loggedUser)),
});

export { DashboardMessage };
export default connect(mapDispatchToProps)(withRouter(DashboardMessage));



// WEBPACK FOOTER //
// ./src/components/DashboardMain/DashboardMessage.js